
import { 
  BookOpen, 
  LineChart, 
  AlertCircle,
  FileSearch, 
  Scale, 
  PanelTop, 
  BarChart3, 
  FileText,
  Settings
} from "lucide-react";
import { Service } from "./types";

export const servicesData: Service[] = [
  {
    id: 1,
    title: "Training",
    description: "Comprehensive training programs designed to help legal professionals quickly master AI tools and methodologies, with customized curriculum for various practice areas.",
    icon: <BookOpen className="h-6 w-6" />,
    color: "bg-sky-600/20"
  },
  {
    id: 2,
    title: "Strategy Consulting",
    description: "Expert guidance on integrating AI into your legal practice with custom implementation roadmaps, technology selection, and process optimization.",
    icon: <LineChart className="h-6 w-6" />,
    color: "bg-blue-600/20"
  },
  {
    id: 3,
    title: "Advisory",
    description: "Ongoing support and consultation to navigate the evolving AI landscape, ensuring your firm remains at the forefront of legal technology innovation.",
    icon: <AlertCircle className="h-6 w-6" />,
    color: "bg-purple-600/20"
  },
  {
    id: 4,
    title: "Custom Workflows",
    description: "Specialized consulting to identify gaps in your current workflows and design bespoke AI-powered automations tailored to streamline your legal operations.",
    icon: <Settings className="h-6 w-6" />,
    color: "bg-green-600/20"
  },
  {
    id: 5,
    title: "Document and Knowledge Management",
    description: "Expert AI consulting to optimize document generation for contracts, pleadings, and legal templates, with customizable strategies and version control solutions.",
    icon: <FileText className="h-6 w-6" />,
    color: "bg-indigo-600/20"
  },
  {
    id: 6,
    title: "Contract Automation",
    description: "Strategic AI advisory services to enhance contract review and analysis, identifying risks, opportunities, and key terms with unparalleled speed and precision.",
    icon: <FileSearch className="h-6 w-6" />,
    color: "bg-cyan-600/20"
  },
  {
    id: 7,
    title: "Legal Research",
    description: "Comprehensive AI-driven consulting to streamline legal research, analyzing thousands of cases, statutes, and regulations to deliver actionable precedents and insights.",
    icon: <PanelTop className="h-6 w-6" />,
    color: "bg-emerald-600/20"
  },
  {
    id: 8,
    title: "Compliance and Risk Management",
    description: "Proactive AI consulting to monitor regulatory changes and ensure compliance, offering customized risk management strategies for your practice areas.",
    icon: <BarChart3 className="h-6 w-6" />,
    color: "bg-red-600/20"
  }
];
